import styled from "@emotion/styled";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { BiImageAdd } from "react-icons/bi";
import Layout from "../layout/Layout";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { registerTestimonials } from "../../../states/actions/testimonialsAction";
import { parseJWT } from "../../../utils/jwtUtils";
import { useTranslation } from "react-i18next";

const CreateTestimonial = () => {
  const imageInput = useRef(null);

  const UploadBox = styled(Box)({
    marginTop: 30,
    height: 150,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderStyle: "dashed",
    borderWidth: "2px",
    borderColor: "divider",
  });

  // use form
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("userInfo");
  const userRole = parseJWT(token);

  const onSubmit = (data, e) => {
    data.photo = getImg;
    data.userId = userRole.id;
    const formData = new FormData();
    Object?.entries(data).map((entry) => {
      const [key, value] = entry;
      formData.append(key, value);
    });
    // dispatch
    dispatch(registerTestimonials(formData));
    reset();
    setTimeout(function () {
      navigate("/all-testimonials");
    }, 2000);
  };

  const [picture, setPicture] = useState(null);
  const [getImg, setImg] = useState(null);
  // when image is uploaded
  const onImageUpload = (e) => {
    e.persist();
    setPicture(URL.createObjectURL(e.target.files[0]));
    setImg(e.target.files[0]);
  };

  const { t: translate } = useTranslation(["Testimonial"]);
  return (
    <Layout title={"Testimonials"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Typography variant="h6" sx={{ marginBottom: "14px" }}>
          {translate("Add Testimonials")}
        </Typography>
        <Paper
          sx={{
            boxShadow: "none !important",
            borderRadius: "12px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            p: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mt: 2, alignItems: "center", gap: 4 }}>
              <div className="w-full">
                <TextField
                  label={translate("Full Name")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  {...register(`full_Name`, {
                    required: true,
                    maxLength: 1000,
                    pattern: /^[A-Za-z\s]/,
                  })}
                />
                {errors.full_Name && (
                  <p className="text-red-500">
                    {" "}
                    {translate("name is invalid")}{" "}
                  </p>
                )}
              </div>
            </Box>

            <Box sx={{ mt: 3 }}>
              <TextField
                label={translate("Clients Say")}
                variant="outlined"
                rows={3}
                fullWidth
                multiline
                {...register(`clients_say`, {
                  required: true,
                  // maxLength: 10000,
                })}
              />
              {errors.clients_say && (
                <p className="text-red-500">
                  {" "}
                  {translate("clients say is required")}
                </p>
              )}
            </Box>

            <input
              // type="file"
              hidden
              ref={imageInput}
              //onChange={(e) => setImage(e.target.files[0])}
              type="file"
              accept="image/*"
              onChange={onImageUpload}
            />
            <UploadBox onClick={() => imageInput.current.click()}>
              {getImg ? (
                <img
                  src={picture}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Box sx={{ textAlign: "center" }}>
                  <BiImageAdd style={{ fontSize: "50px", color: "#027edd" }} />
                  <Typography>
                    Drop your images here or
                    <span style={{ color: "#027edd", cursor: "pointer" }}>
                      browse
                    </span>
                  </Typography>
                  <Typography sx={{ fontSize: "12px" }}>
                    JPG, PNG, and GIF images are allowed
                  </Typography>
                </Box>
              )}
            </UploadBox>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "30px",
                gap: 4,
              }}
            >
              <Button
                variant="contained"
                sx={{ borderRadius: "5px" }}
                type="submit"
              >
                {translate(" Submit ")}
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Layout>
  );
};

export default CreateTestimonial;
